/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { changeGreetingStatusModelSchema } from "../changeGreetingStatusModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

/**
 * @description Статус изменен
 */
export const patchApiGreetingsStatus200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации | Шаблон с условием показа \\\"Ежедневно\\\" уже добавлен в расписание
 */
export const patchApiGreetingsStatus400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiGreetingsStatus401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiGreetingsStatus403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Шаблон приветственного экрана не найден
 */
export const patchApiGreetingsStatus404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiGreetingsStatus500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const patchApiGreetingsStatusMutationRequestSchema = z.lazy(() => changeGreetingStatusModelSchema).describe("Тело запроса")

export const patchApiGreetingsStatusMutationResponseSchema = z.lazy(() => patchApiGreetingsStatus200Schema)